import {
  Accordion,
  Avatar,
  Button,
  Center,
  Divider,
  Flex,
  Text,
  Tooltip,
  useMantineTheme,
} from "@mantine/core";
import { TagCapsules } from "../../../../components";
import { TEMP_GraficProduct } from "../../../../assets";
import BoxShop from "./Box";
import { IColor } from "../../../../utils/selectColors";
import { IMyProducts } from "../../../../interfaces/MyProducts";
import AccordionHistory from "./AccordionHistory";
import AccordionInfo from "./AccordionInfo";
import { client_selected } from "../../../../client";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  tradutorCategory,
  tradutorSubcategory,
} from "../../../../utils/SubCategorys";

interface IProps {
  myProduct: IMyProducts;
}

const CardShopping = ({ myProduct }: IProps) => {
  const { t } = useTranslation();
  const theme = useMantineTheme();
  const name = client_selected.name;
  const navigate = useNavigate();

  const handleRedirectToOrders = () => {
    navigate(`/operacoes/ordens?productId=${myProduct.id}`);
  };

  const handleRedirectToPositions = () => {
    navigate(`/operacoes/posicoes?productId=${myProduct.id}`);
  };

  return (
    <Flex
      sx={{
        boxShadow: "0px 10px 40px rgba(0, 0, 0, 0.05)",
        borderRadius: "12px",
      }}
    >
      <Flex
        w="100%"
        id="CardProduct"
        p={{ base: 24, 991: 32 }}
        direction={"column"}
      >
        <Flex
          id="lineTwoCardProduct"
          gap={32}
          justify={"space-between"}
          direction={{ base: "column", 991: "row" }}
        >
          <Flex gap={16} align="center" w="100%" maw={320}>
            <Avatar
              src={!!myProduct?.icon ? myProduct?.icon : TEMP_GraficProduct}
              size={80}
              radius={8}
            />
            <Flex justify="center" direction="column" w="100%" maw="224px">
              <Flex gap="8px">
                <TagCapsules colorTag={IColor.orange} border>
                  {t(tradutorCategory(myProduct?.category).title)}
                </TagCapsules>
                {myProduct?.subcategory ? (
                  <TagCapsules colorTag={IColor.yellow} border>
                    {t(tradutorSubcategory(myProduct?.subcategory).title)}
                  </TagCapsules>
                ) : null}
              </Flex>

              <Tooltip label={myProduct?.title} withArrow>
                <Text
                  truncate
                  fz={{ base: 18 }}
                  fw={{ base: 600 }}
                  lh={{ base: "155%" }}
                  c="basic.5"
                >
                  {myProduct?.title}
                </Text>
              </Tooltip>
            </Flex>
          </Flex>
          <Flex
            gap={"24px"}
            w="100%"
            justify={"end"}
            wrap={{ base: "wrap", 1600: "nowrap" }}
          >
            <Flex
              gap="8px"
              direction={"column"}
              maw={{ base: "100%", 991: "246px" }}
              w="100%"
            >
              <Divider
                size={22}
                w="100%"
                color={theme.colors.primaryOpacity[2]}
              />
              <Flex
                gap="24px"
                w={"100%"}
                align={"center"}
                justify={{ base: "start", 991: "space-between" }}
              >
                <BoxShop
                  title={t(
                    "meu_portfolio.meus_serviços.card_product.name_plan"
                  )}
                  content={
                    myProduct.active
                      ? t("global.status.active")
                      : t("global.status.inactive")
                  }
                  contentUppercase
                />
                <BoxShop
                  title={t("meu_portfolio.meus_serviços.card_product.sold_by")}
                  content={myProduct.whitelabel || name}
                />
              </Flex>
            </Flex>
            <Flex
              gap="8px"
              direction={"column"}
              maw={{ base: "100%", 991: "470px" }}
              w="100%"
            >
              <Center
                h="22px"
                color={theme.colors.basic[4]}
                bg={theme.colors.primaryOpacity[1]}
              >
                <Text
                  fz={"14px"}
                  fw={400}
                  lh={"22px"}
                  ff={"barlow"}
                  tt="uppercase"
                  color={theme.colors.basic[4]}
                >
                  {t("meu_portfolio.meus_serviços.card_product.quantity")}
                </Text>
              </Center>
              <Flex
                gap="24px"
                w={"100%"}
                align={"center"}
                justify={"space-between"}
                wrap={{ base: "wrap", 600: "nowrap" }}
              >
                <BoxShop
                  title={t("meu_portfolio.meus_serviços.card_product.sell")}
                  content={myProduct.counts.total.toString()}
                />
                <BoxShop
                  title={t("meu_portfolio.meus_serviços.card_product.cancel")}
                  content={myProduct.counts.cancelled.toString()}
                />
                <BoxShop
                  title={t("meu_portfolio.meus_serviços.card_product.copy")}
                  content={myProduct.counts.copying.toString()}
                />
                <BoxShop
                  title={t("meu_portfolio.meus_serviços.card_product.pending")}
                  content={myProduct.counts.pending.toString()}
                />
                <BoxShop
                  title={t("meu_portfolio.meus_serviços.card_product.inactive")}
                  content={myProduct.counts.inactive.toString()}
                />
              </Flex>
            </Flex>
          </Flex>
        </Flex>
        <Flex
          gap={{ base: 16 }}
          w="fit"
          justify="space-between"
          wrap={{ base: "wrap", 991: "nowrap" }}
          pt={{ base: 16, 991: 22 }}
          pb="16px"
        >
          <Button
            variant={"primary"}
            miw="225px"
            w={{ base: "100%" }}
            onClick={handleRedirectToPositions}
          >
            {t(
              "meu_portfolio.meus_serviços.card_product.button_access_positions"
            )}
          </Button>
          <Button
            variant={"primary"}
            miw="225px"
            w={{ base: "100%" }}
            onClick={handleRedirectToOrders}
          >
            {t("meu_portfolio.meus_serviços.card_product.button_access_orders")}
          </Button>
        </Flex>
        <Accordion>
          <AccordionInfo product={myProduct} />
          <AccordionHistory product={myProduct} />
        </Accordion>
      </Flex>
    </Flex>
  );
};
export default CardShopping;
